module.exports = __webpack_public_path__ + "static/media/l-est-republicain.7481b32b.jpg";